import React, { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { Button, Spinner } from "../components/ui";
import api from "../lib/api";
import { CheckCircle2, XCircle, Mail } from "lucide-react";

export default function VerifyEmail() {
  const { lang, setUser } = useApp();
  const navigate = useNavigate();
  const tr = (fr, en) => (lang === "fr" ? fr : en);
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = new URLSearchParams(window.location.search).get("token");
    (async () => {
      if (!token) {
        setStatus("error");
        setMessage(tr("Lien de confirmation invalide.", "Invalid confirmation link."));
        return;
      }
      try {
        const { data } = await api.post("/auth/verify-email", { token });
        setUser(data);
        setStatus("success");
        setTimeout(() => navigate("/", { replace: true }), 1200);
      } catch (err) {
        const detail = err?.response?.data?.detail;
        setStatus("error");
        setMessage(typeof detail === "string" ? detail : tr("Ce lien est invalide ou a expiré.", "This link is invalid or has expired."));
      }
    })();
  }, []);

  return (
    <div className="h-screen w-full flex items-center justify-center bg-background p-6" data-testid="verify-email-page">
      <div className="w-full max-w-sm text-center">
        {status === "verifying" && (
          <div className="space-y-4" data-testid="verify-loading">
            <div className="w-12 h-12 rounded-xl bg-primary/15 text-primary flex items-center justify-center mx-auto"><Mail className="w-6 h-6" /></div>
            <Spinner className="w-6 h-6 text-text-secondary mx-auto" />
            <p className="text-sm text-text-secondary">{tr("Confirmation de votre email…", "Confirming your email…")}</p>
          </div>
        )}
        {status === "success" && (
          <div className="space-y-4" data-testid="verify-success">
            <div className="w-12 h-12 rounded-xl bg-emerald-500/15 text-emerald-500 flex items-center justify-center mx-auto"><CheckCircle2 className="w-6 h-6" /></div>
            <h1 className="font-heading font-bold text-xl text-text-primary">{tr("Email confirmé !", "Email confirmed!")}</h1>
            <p className="text-sm text-text-secondary">{tr("Votre essai gratuit de 7 jours démarre. Redirection…", "Your 7-day free trial starts now. Redirecting…")}</p>
          </div>
        )}
        {status === "error" && (
          <div className="space-y-4" data-testid="verify-error">
            <div className="w-12 h-12 rounded-xl bg-red-500/15 text-red-500 flex items-center justify-center mx-auto"><XCircle className="w-6 h-6" /></div>
            <h1 className="font-heading font-bold text-xl text-text-primary">{tr("Échec de la confirmation", "Confirmation failed")}</h1>
            <p className="text-sm text-text-secondary">{message}</p>
            <Link to="/login"><Button variant="outline" size="lg" className="w-full" data-testid="verify-back-login">{tr("Retour à la connexion", "Back to sign in")}</Button></Link>
          </div>
        )}
      </div>
    </div>
  );
}
